import { InjectionToken, Injectable, Inject, PLATFORM_ID, NgModule } from '@angular/core';
import { StateToken, actionMatcher, InitState, UpdateState, getValue, setValue, NGXS_PLUGINS } from '@ngxs/store';
import { isPlatformServer } from '@angular/common';
import { tap } from 'rxjs/operators';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
import * as ɵngcc0 from '@angular/core';
const StorageOption = {
    LocalStorage: 0,
    SessionStorage: 1,
};
/**
 * @record
 */
function NgxsStoragePluginOptions() { }
if (false) {
    /**
     * Key for the state slice to store in the storage engine.
     * @type {?|undefined}
     */
    NgxsStoragePluginOptions.prototype.key;
    /**
     * Storage engine to use. Deaults to localStorage but can provide
     *
     * sessionStorage or custom implementation of the StorageEngine interface
     * @type {?|undefined}
     */
    NgxsStoragePluginOptions.prototype.storage;
    /**
     * Migration strategies.
     * @type {?|undefined}
     */
    NgxsStoragePluginOptions.prototype.migrations;
    /**
     * Serailizer for the object before its pushed into the engine.
     * @param {?} obj
     * @return {?}
     */
    NgxsStoragePluginOptions.prototype.serialize = function (obj) { };
    /**
     * Deserializer for the object before its pulled out of the engine.
     * @param {?} obj
     * @return {?}
     */
    NgxsStoragePluginOptions.prototype.deserialize = function (obj) { };
    /**
     * Method to alter object before serialization.
     * @param {?} obj
     * @param {?} key
     * @return {?}
     */
    NgxsStoragePluginOptions.prototype.beforeSerialize = function (obj, key) { };
    /**
     * Method to alter object after deserialization.
     * @param {?} obj
     * @param {?} key
     * @return {?}
     */
    NgxsStoragePluginOptions.prototype.afterDeserialize = function (obj, key) { };
}
/** @type {?} */
const NGXS_STORAGE_PLUGIN_OPTIONS = new InjectionToken('NGXS_STORAGE_PLUGIN_OPTION');
/** @type {?} */
const STORAGE_ENGINE = new InjectionToken('STORAGE_ENGINE');
/**
 * @record
 */
function StorageEngine() { }
if (false) {
    /** @type {?} */
    StorageEngine.prototype.length;
    /**
     * @param {?} key
     * @return {?}
     */
    StorageEngine.prototype.getItem = function (key) { };
    /**
     * @param {?} key
     * @param {?} val
     * @return {?}
     */
    StorageEngine.prototype.setItem = function (key, val) { };
    /**
     * @param {?} key
     * @return {?}
     */
    StorageEngine.prototype.removeItem = function (key) { };
    /**
     * @return {?}
     */
    StorageEngine.prototype.clear = function () { };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * If the `key` option is not provided then the below constant
 * will be used as a default key
 * @type {?}
 */
const DEFAULT_STATE_KEY = '@@STATE';
/**
 * This key is used to retrieve static metadatas on state classes.
 * This constant is taken from the core codebase
 * @type {?}
 */
const META_OPTIONS_KEY = 'NGXS_OPTIONS_META';
/**
 * @param {?} key
 * @return {?}
 */
function transformKeyOption(key) {
    if (!Array.isArray(key)) {
        key = [key];
    }
    return key.map((/**
     * @param {?} token
     * @return {?}
     */
    (token) => {
        // If it has the `NGXS_OPTIONS_META` key then it means the developer
        // has provided state class like `key: [AuthState]`.
        if (token.hasOwnProperty(META_OPTIONS_KEY)) {
            // The `name` property will be an actual state name or a `StateToken`.
            token = ((/** @type {?} */ (token)))[META_OPTIONS_KEY].name;
        }
        return token instanceof StateToken ? token.getName() : ((/** @type {?} */ (token)));
    }));
}
/**
 * @param {?} options
 * @return {?}
 */
function storageOptionsFactory(options) {
    if (options !== undefined && options.key) {
        options.key = transformKeyOption(options.key);
    }
    return Object.assign({ key: [DEFAULT_STATE_KEY], storage: 0 /* LocalStorage */, serialize: JSON.stringify, deserialize: JSON.parse, beforeSerialize: (/**
         * @param {?} obj
         * @return {?}
         */
        obj => obj), afterDeserialize: (/**
         * @param {?} obj
         * @return {?}
         */
        obj => obj) }, options);
}
/**
 * @param {?} options
 * @param {?} platformId
 * @return {?}
 */
function engineFactory(options, platformId) {
    if (isPlatformServer(platformId)) {
        return null;
    }
    if (options.storage === 0 /* LocalStorage */) {
        return localStorage;
    }
    else if (options.storage === 1 /* SessionStorage */) {
        return sessionStorage;
    }
    return null;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxsStoragePlugin {
    /**
     * @param {?} _options
     * @param {?} _engine
     * @param {?} _platformId
     */
    constructor(_options, _engine, _platformId) {
        this._options = _options;
        this._engine = _engine;
        this._platformId = _platformId;
        // We cast to `string[]` here as we're sure that this option has been
        // transformed by the `storageOptionsFactory` function that provided token.
        this._keys = (/** @type {?} */ (this._options.key));
        // We default to `[DEFAULT_STATE_KEY]` if the user explicitly does not provide the `key` option.
        this._usesDefaultStateKey = this._keys.length === 1 && this._keys[0] === DEFAULT_STATE_KEY;
    }
    /**
     * @param {?} state
     * @param {?} event
     * @param {?} next
     * @return {?}
     */
    handle(state, event, next) {
        if (isPlatformServer(this._platformId) && this._engine === null) {
            return next(state, event);
        }
        /** @type {?} */
        const matches = actionMatcher(event);
        /** @type {?} */
        const isInitAction = matches(InitState);
        /** @type {?} */
        const isUpdateAction = matches(UpdateState);
        /** @type {?} */
        const isInitOrUpdateAction = isInitAction || isUpdateAction;
        /** @type {?} */
        let hasMigration = false;
        if (isInitOrUpdateAction) {
            /** @type {?} */
            const addedStates = isUpdateAction && event.addedStates;
            for (const key of this._keys) {
                // We're checking what states have been added by NGXS and if any of these states should be handled by
                // the storage plugin. For instance, we only want to deserialize the `auth` state, NGXS has added
                // the `user` state, the storage plugin will be rerun and will do redundant deserialization.
                // `usesDefaultStateKey` is necessary to check since `event.addedStates` never contains `@@STATE`.
                if (!this._usesDefaultStateKey && addedStates) {
                    // We support providing keys that can be deeply nested via dot notation, for instance,
                    // `keys: ['myState.myProperty']` is a valid key.
                    // The state name should always go first. The below code checks if the `key` includes dot
                    // notation and extracts the state name out of the key.
                    // Given the `key` is `myState.myProperty`, the `addedStates` will only contain `myState`.
                    /** @type {?} */
                    const dotNotationIndex = key.indexOf(DOT);
                    /** @type {?} */
                    const stateName = dotNotationIndex > -1 ? key.slice(0, dotNotationIndex) : key;
                    if (!addedStates.hasOwnProperty(stateName)) {
                        continue;
                    }
                }
                /** @type {?} */
                let storedValue = this._engine.getItem((/** @type {?} */ (key)));
                if (storedValue !== 'undefined' && storedValue != null) {
                    try {
                        /** @type {?} */
                        const newVal = (/** @type {?} */ (this._options.deserialize))(storedValue);
                        storedValue = (/** @type {?} */ (this._options.afterDeserialize))(newVal, key);
                    }
                    catch (_a) {
                        // Caretaker note: we have still left the `typeof` condition in order to avoid
                        // creating a breaking change for projects that still use the View Engine.
                        if (typeof ngDevMode === 'undefined' || ngDevMode) {
                            console.error(`Error ocurred while deserializing the ${key} store value, falling back to empty object, the value obtained from the store: `, storedValue);
                        }
                        storedValue = {};
                    }
                    if (this._options.migrations) {
                        this._options.migrations.forEach((/**
                         * @param {?} strategy
                         * @return {?}
                         */
                        strategy => {
                            /** @type {?} */
                            const versionMatch = strategy.version === getValue(storedValue, strategy.versionKey || 'version');
                            /** @type {?} */
                            const keyMatch = (!strategy.key && this._usesDefaultStateKey) || strategy.key === key;
                            if (versionMatch && keyMatch) {
                                storedValue = strategy.migrate(storedValue);
                                hasMigration = true;
                            }
                        }));
                    }
                    if (!this._usesDefaultStateKey) {
                        state = setValue(state, (/** @type {?} */ (key)), storedValue);
                    }
                    else {
                        // The `UpdateState` action is dispatched whenever the feature state is added.
                        // The below condition is met only when the `UpdateState` is dispatched.
                        // Let's assume that we have 2 states `counter` and `@ngxs/router-plugin` state.
                        // `CounterState` is provided on the root level when calling `NgxsModule.forRoot()`
                        // and `@ngxs/router-plugin` is provided as a feature state.
                        // The storage plugin may save the `counter` state value as `10` before.
                        // The `CounterState` may implement the `ngxsOnInit` hook and call `ctx.setState(999)`.
                        // The storage plugin will re-hydrate the whole state when the `RouterState` is registered,
                        // and the `counter` state will again equal `10` (not `999`).
                        if (storedValue && addedStates && Object.keys(addedStates).length > 0) {
                            storedValue = Object.keys(addedStates).reduce((/**
                             * @param {?} accumulator
                             * @param {?} addedState
                             * @return {?}
                             */
                            (accumulator, addedState) => {
                                // The `storedValue` may equal the whole state (when the default state key is used).
                                // If `addedStates` contains only `router` then we want to merge the state only
                                // with the `router` value.
                                // Let's assume that the `storedValue` is an object:
                                // `{ counter: 10, router: {...} }`
                                // This will pick only the `router` object from the `storedValue` and `counter`
                                // state will not be re-hydrated unnecessary.
                                if (storedValue.hasOwnProperty(addedState)) {
                                    accumulator[addedState] = storedValue[addedState];
                                }
                                return accumulator;
                            }), (/** @type {?} */ ({})));
                        }
                        state = Object.assign({}, state, storedValue);
                    }
                }
            }
        }
        return next(state, event).pipe(tap((/**
         * @param {?} nextState
         * @return {?}
         */
        nextState => {
            if (!isInitOrUpdateAction || (isInitOrUpdateAction && hasMigration)) {
                for (const key of this._keys) {
                    /** @type {?} */
                    let val = nextState;
                    if (key !== DEFAULT_STATE_KEY) {
                        val = getValue(nextState, (/** @type {?} */ (key)));
                    }
                    try {
                        /** @type {?} */
                        const newVal = (/** @type {?} */ (this._options.beforeSerialize))(val, key);
                        this._engine.setItem((/** @type {?} */ (key)), (/** @type {?} */ (this._options.serialize))(newVal));
                    }
                    catch (error) {
                        // Caretaker note: we have still left the `typeof` condition in order to avoid
                        // creating a breaking change for projects that still use the View Engine.
                        if (typeof ngDevMode === 'undefined' || ngDevMode) {
                            if (error &&
                                (error.name === 'QuotaExceededError' ||
                                    error.name === 'NS_ERROR_DOM_QUOTA_REACHED')) {
                                console.error(`The ${key} store value exceeds the browser storage quota: `, val);
                            }
                            else {
                                console.error(`Error ocurred while serializing the ${key} store value, value not updated, the value obtained from the store: `, val);
                            }
                        }
                    }
                }
            }
        })));
    }
}
NgxsStoragePlugin.ɵfac = function NgxsStoragePlugin_Factory(t) { return new (t || NgxsStoragePlugin)(ɵngcc0.ɵɵinject(NGXS_STORAGE_PLUGIN_OPTIONS), ɵngcc0.ɵɵinject(STORAGE_ENGINE), ɵngcc0.ɵɵinject(PLATFORM_ID)); };
NgxsStoragePlugin.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NgxsStoragePlugin, factory: NgxsStoragePlugin.ɵfac });
/** @nocollapse */
NgxsStoragePlugin.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [NGXS_STORAGE_PLUGIN_OPTIONS,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [STORAGE_ENGINE,] }] },
    { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxsStoragePlugin, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [NGXS_STORAGE_PLUGIN_OPTIONS]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [STORAGE_ENGINE]
            }] }, { type: String, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    NgxsStoragePlugin.prototype._keys;
    /**
     * @type {?}
     * @private
     */
    NgxsStoragePlugin.prototype._usesDefaultStateKey;
    /**
     * @type {?}
     * @private
     */
    NgxsStoragePlugin.prototype._options;
    /**
     * @type {?}
     * @private
     */
    NgxsStoragePlugin.prototype._engine;
    /**
     * @type {?}
     * @private
     */
    NgxsStoragePlugin.prototype._platformId;
}
/** @type {?} */
const DOT = '.';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const USER_OPTIONS = new InjectionToken('USER_OPTIONS');
class NgxsStoragePluginModule {
    /**
     * @param {?=} options
     * @return {?}
     */
    static forRoot(options) {
        return {
            ngModule: NgxsStoragePluginModule,
            providers: [
                {
                    provide: NGXS_PLUGINS,
                    useClass: NgxsStoragePlugin,
                    multi: true
                },
                {
                    provide: USER_OPTIONS,
                    useValue: options
                },
                {
                    provide: NGXS_STORAGE_PLUGIN_OPTIONS,
                    useFactory: storageOptionsFactory,
                    deps: [USER_OPTIONS]
                },
                {
                    provide: STORAGE_ENGINE,
                    useFactory: engineFactory,
                    deps: [NGXS_STORAGE_PLUGIN_OPTIONS, PLATFORM_ID]
                }
            ]
        };
    }
}
NgxsStoragePluginModule.ɵfac = function NgxsStoragePluginModule_Factory(t) { return new (t || NgxsStoragePluginModule)(); };
NgxsStoragePluginModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxsStoragePluginModule });
NgxsStoragePluginModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxsStoragePluginModule, [{
        type: NgModule
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NGXS_STORAGE_PLUGIN_OPTIONS, NgxsStoragePlugin, NgxsStoragePluginModule, STORAGE_ENGINE, USER_OPTIONS as ɵa, storageOptionsFactory as ɵb, engineFactory as ɵc };

